import Graphic from "@arcgis/core/Graphic";

import {
  useState,
  createContext
} from "react";

const ParkContext = createContext<
  Partial<{
    clickedPark: any;
    setClickedPark: (clickedPark: any) => void;
    clickedParkServiceArea: any;
    setClickedParkServiceArea: (clickedPark: any) => void;
  }>
>({});
export default ParkContext;

export function ParkProvider(props: any) {
  const [clickedPark, setClickedPark] = useState<Graphic>();
  const [clickedParkServiceArea, setClickedParkServiceArea] =
    useState<Graphic>();

  return (
    <ParkContext.Provider
      value={{
        clickedPark,
        setClickedPark,
        clickedParkServiceArea,
        setClickedParkServiceArea,
      }}
      {...props}
    ></ParkContext.Provider>
  );
}
